import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const NewDocument = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 124 64"
        data-fill-none
      >
        <rect
          x="0.5"
          y="0.5"
          width="122.429"
          height="63"
          rx="3.5"
          fill="#ECF2FF"
        />
        <rect
          x="0.5"
          y="0.5"
          width="122.429"
          height="63"
          rx="3.5"
          stroke="#C9DBFF"
        />
        <path
          d="M74.9333 43H60.4667H52.2H48.0667C46.9644 43 46 42.1445 46 41.1666V22.8333C46 21.8556 46.9644 21 48.0667 21H74.9333C76.0356 21 77 21.8556 77 22.8333V41.1666C77 42.1445 76.0356 43 74.9333 43Z"
          fill="white"
          stroke="#0C5CEF"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="49"
          y="29"
          width="13"
          height="1.2"
          rx="0.6"
          fill="#0C5CEF"
        />
        <rect
          x="49"
          y="32.1992"
          width="24"
          height="1.2"
          rx="0.6"
          fill="#0C5CEF"
        />
        <rect
          x="49"
          y="35.4004"
          width="19"
          height="1.2"
          rx="0.6"
          fill="#0C5CEF"
        />
        <rect
          x="69"
          y="13"
          width="16"
          height="16"
          rx="8"
          fill="#0C5CEF"
        />
        <path
          d="M77 17V25"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73 21H81"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
